import React from 'react';
import { Box } from '@mui/material';
import AttachmentFile from '@/components/AttachmentFile';
import { RemoteFile } from '@/components/file-thumbnail/utils';
import MobileBottomSheet from '@/components/@IntranetLibrary/MobileBottomSheet';

type AttachmentSheetProps = {
  open: boolean;
  files: RemoteFile[];
  disabled?: boolean;
  onClose: () => void;
};

// MUI Modal (BoardDetailModal) has z-index 1300
// Use 1400 to ensure drawer appears above the modal
const ATTACHMENT_SHEET_Z_INDEX = 1400;

const AttachmentSheet = ({
  open,
  files,
  disabled,
  onClose,
}: AttachmentSheetProps) => {
  return (
    <MobileBottomSheet
      open={open}
      height="auto"
      onClose={onClose}
      zIndex={ATTACHMENT_SHEET_Z_INDEX}
      showHandle={true}
      notifyAppBar
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: '8px',
          padding: '16px 20px',
        }}
      >
        {files.map((file, index) => (
          <AttachmentFile
            key={index}
            file={file}
            disabled={disabled}
            isDeletable={false}
            isPreviewable={true}
          />
        ))}
      </Box>
    </MobileBottomSheet>
  );
};

export default AttachmentSheet;
